import { NovelMeta } from "./NovelMets"
import { postMypageNovel } from "../../../api/v1/mypage/novel/post"
import { MypageNovelPostInputModel } from "../../../api/v1/mypage/novel/PostInputModel"

export const createNovel = (novel: NovelMeta): Promise<{ id: number }> => {
  return postMypageNovel(new MypageNovelPostInputModel(novel))
}
